'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$() {
  this.aJX = null;
  this.aKe = null;
  this.aK0 = null;
  this.aK1 = false;
  this.aK6 = null;
  this.aK7 = false;
  this.aKc = null;
  this.aKd = false;
  this.aJY = null;
  this.aJZ = false;
  this.aKa = null;
  this.aKb = false;
  this.aK8 = null;
  this.aK9 = false;
  this.aK2 = null;
  this.aK3 = false;
  this.aK4 = null;
  this.aK5 = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$ = this;
  this.aJX = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$();
  this.aKe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$.prototype = $p;
$p.eR = (function() {
  return this.aJX;
});
$p.eO = (function() {
  return this.aKe;
});
$p.bW = (function() {
  if ((!this.aK1)) {
    this.aK0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aK1 = true;
  }
  return this.aK0;
});
$p.b9 = (function() {
  if ((!this.aK7)) {
    this.aK6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aK7 = true;
  }
  return this.aK6;
});
$p.b3 = (function() {
  if ((!this.aKd)) {
    this.aKc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aKd = true;
  }
  return this.aKc;
});
$p.aG = (function() {
  if ((!this.aJZ)) {
    this.aJY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aJZ = true;
  }
  return this.aJY;
});
$p.az = (function() {
  if ((!this.aKb)) {
    this.aKa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aKb = true;
  }
  return this.aKa;
});
$p.aY = (function() {
  if ((!this.aK9)) {
    this.aK8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aK9 = true;
  }
  return this.aK8;
});
$p.yp = (function() {
  if ((!this.aK3)) {
    this.aK2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "HS Code";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aK3 = true;
  }
  return this.aK2;
});
$p.ass = (function() {
  if ((!this.aK5)) {
    this.aK4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aK5 = true;
  }
  return this.aK4;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$, "app.data.data_point_types$package$HarmonizedSystemCodeForm$", ({
  FN: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$() {
  this.aJV = null;
  this.aJW = false;
  this.aJT = null;
  this.aJU = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$.prototype = $p;
$p.aA = (function() {
  if ((!this.aJW)) {
    this.aJV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aJW = true;
  }
  return this.aJV;
});
$p.asj = (function() {
  if ((!this.aJU)) {
    this.aJT = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$().yp();
    this.aJU = true;
  }
  return this.aJT;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$, "app.data.data_point_types$package$HarmonizedSystemCode$", ({
  FM: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCode$ };
//# sourceMappingURL=app.data.data_point_types$package$-Harmonized-System-Code$.js.map
